import type { PublishingOptionType } from '../types';

const templatePublishingOptions: PublishingOptionType[] = [
  {
    id: 'DRAFT',
    title: 'Draft',
    description: 'This template is a work in progress and unavailable to use on new contracts.',
  },
  {
    id: 'REVIEW',
    title: 'Review',
    description: 'Submit this template for Super Admin sign-off before publishing.',
  },
  {
    id: 'PUBLISHED',
    title: 'Published',
    description: 'Make this template available to use when creating new contracts.',
  },
  {
    id: 'ARCHIVED',
    title: 'Archived',
    description: 'Prevent this template from being used when creating new contracts.',
  },
];

export const getTemplatePublishingOptions = (hasTemplateReviewWorkflow: boolean): PublishingOptionType[] =>
  hasTemplateReviewWorkflow ? templatePublishingOptions : templatePublishingOptions.filter(({ id }) => id !== 'REVIEW');

export const getSubmissionPublishingOptions = (hasFirmOrderStatus: boolean): PublishingOptionType[] => [
  {
    id: 'DRAFT',
    title: 'Draft',
    description: 'This contract is a work in progress and not complete.',
  },
  {
    id: 'REVIEW',
    title: 'Review',
    description: 'This contract is being reviewed. It must be returned to draft for edits.',
  },
  ...(hasFirmOrderStatus
    ? [
        {
          id: 'FIRM_ORDER',
          title: 'Firm Order',
          description: 'This contract is going to firm order and will soon be bound.',
        } as const,
      ]
    : []),
  {
    id: 'FINAL',
    title: 'Final',
    description: 'This contract is complete. Further changes will be made as endorsements.',
  },
  {
    id: 'ARCHIVED',
    title: 'Archived',
    description: 'This contract is not being used.',
  },
];

const endorsementPublishingOptions: PublishingOptionType[] = [
  {
    id: 'DRAFT',
    title: 'Draft',
    description: 'This endorsement is a work in progress and not complete.',
  },
  {
    id: 'REVIEW',
    title: 'Review',
    description: 'This endorsement is being reviewed. It must be returned to draft for edits.',
  },
  {
    id: 'FINAL',
    title: 'Final',
    description: 'This endorsement is complete.',
  },
  {
    id: 'ARCHIVED',
    title: 'Archived',
    description: 'This endorsement is not being used.',
  },
];

export const getEndorsementPublishingOptions = (hasEndorsementReview: boolean): PublishingOptionType[] =>
  hasEndorsementReview
    ? endorsementPublishingOptions
    : endorsementPublishingOptions.filter(({ id }) => id !== 'REVIEW');

export enum ViewPath {
  Contract = 'contract',
  Form = 'form',
  Endorsements = 'endorsements',
  EndorsementView = 'endorsement-view',
  ComparisonView = 'comparison-view',
}

export enum EntityField {
  Name = 'name',
  TemplateBase = 'sourceResourceId',
  Branding = 'branding',
  BrandingId = 'branding_id',
  ClassOfBusiness = 'class_of_business',
  Teams = 'teams',
}
